import * as Preact from "preact"

import Navigation from "@fae/source/engine/navigating/Navigation.js"

import Audiomix from "@fae/source/engine/Audiomix.js"
import Frame from "@fae/source/views/components/Frame.jsx"
import Portrait from "@fae/source/views/components/Portrait.jsx"
import LoadingScreen from "@fae/source/data/games/ember/views/screens/LoadingScreen.jsx"
import "./EmbarkScreen.less"

let preload = {"isLoading": true}
import("@fae/source/data/preload.js").then((module) => preload = module.default)

import game from "@fae/source/data/games/ember/index.js"

export default class EmbarkScreen {
    render() {
        // if(window.hasClicked != true) {
        //     return (
        //         <Frame>
        //             <div class="WaitForClickScreen">
        //                 <div class="Button" onClick={() => window.hasClicked = true}>
        //                     <svg stroke-width="2" class="svgicon icon_play" width="24" height="24" aria-hidden="" fill="none" stroke="currentColor" stroke-linejoin="round" role="img" version="1.1" viewBox="0 0 24 24" stroke-linecap="round"><circle cx="12" cy="12" r="10"></circle><polygon points="10 8 16 12 10 16 10 8"></polygon></svg>
        //                     Run game
        //                 </div>
        //             </div>
        //         </Frame>
        //     )
        // }
        if(preload.isLoading) {
            return <LoadingScreen/>
        }
        return (
            <Frame>
                <div class="EmberEmbarkScreen">
                    <div class="Blackout"/>
                    <div class="Header">
                        <div class="Text">Click on a card to flip it.</div>
                    </div>
                    <div class="Units">
                        {Object.values(game.player.units).map((partyunit) => {
                            const unit = {...partyunit, ...game.unitJobs[partyunit.jobKey]}
                            if(unit.isOverworldVisible != true) return
                            if(unit.isOverworldSelectable != true) return
                            return (
                                <div class="Unit"
                                    isRevealed={unit.isOverworldRevealed}
                                    isSelectable={unit.isOverworldSelectable}>
                                    <Card unit={unit}/>
                                    <div class="Details">
                                        <div class="Description">{unit.description ?? "???"}</div>
                                        <div class="LearnMoreButton">Click here for more details.</div>
                                    </div>
                                </div>
                            )
                        })}
                    </div>
                    <div class="EmbarkButton" onClick={this.onConfirmEmbark} isVisible={this.isReady}>
                        <div class="Text">Embark</div>
                    </div>
                </div>
            </Frame>
        )
    }
    get isReady() {
        const units = Object.values(game.player.units).filter((unit) => {
            return unit.isOverworldRevealed == true
        })

        return units.length == 3
    }
    onConfirmEmbark() {
        Audiomix.trigger("UI:Confirm")
        window.setTimeout(function() {
            Navigation.go("/games/ember/chapters/X-0")
        }, 250)
    }
}

class Card {
    render() {
        const unit = this.props.unit
        if(unit == undefined) return
        return (
            <div class="Card" onClick={this.onClick}>
                <div class="CardBack"/>
                <div class="CardFront">
                    <Portrait portrait={unit.portraits?.neutral}/>
                    <div class="Number">
                        <div class="Text">
                            {unit.number}
                        </div>
                    </div>
                    <div class="Title">
                        <div class="Text">
                            {unit.jobName}
                        </div>
                    </div>
                </div>
            </div>
        )
    }
    get onClick() {
        return (event) => {
            const unit = this.props.unit
            if(unit.isOverworldSelectable == false) return
            Audiomix.trigger("Card:Flip")
            game.player.units[unit.key].isOverworldRevealed = true
        }
    }
}
